import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/room`; // Replace with your actual API URL

const customHeaders = {
    'Content-Type': 'application/json'
  };

// Get all room types
        //  @ts-ignore 

export const fetchRoomTable = async (page,limit) => {
  const response = await axios.get(`${API_URL}/table?page=${page}&limit=${limit}`,{headers: customHeaders});
  return response.data;
};
export const fetchRoom = async () => {
    const response = await axios.get(`${API_URL}`,{headers: customHeaders});
    return response.data;
  };
export const fetchRoomById = async (id: string) => {
    const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
    return response.data;
  };
// Create a new room type
export const addRoom = async (newRoomType: any) => {
  const response = await axios.post(API_URL, newRoomType,{headers: customHeaders});
  return response.data;
};

// Edit an existing room type
export const updateRoom = async (id: string, updatedRoomType: any) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedRoomType,{headers: customHeaders});
  return response.data;
};

// Delete a room type
export const removeRoom = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`,{headers: customHeaders});
  return response.data;
};
